import { useState, useEffect, Component } from 'react'
import { bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
import { useSearchParams, useLocation } from 'react-router-dom'
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import {
    getContentMarkerReview, getMakeasReviewed, getArchiveArticle,
    getImproveArticle, getAuthandstatus, getReviewHistoryLog, correctPlanningCategory
} from "../../redux/Actions/PowerDataQuery";
import ArticleDiff from '../ArticleDiff/ArticleDiff';
import { useNavigate } from "react-router-dom";
import { IHealingCompleteParams } from "../Interface/Params/IAutoHealingPayload"
import {  useMsal, useAccount } from "@azure/msal-react";
import ExceptionReportDialog from "../CustomDialog/ExceptionReportDialog/ExceptionReportDialog";
import { formatDateToUTCStringDate } from '../Utilities/CommonFunction';
import { getAPIService } from "../../redux/Actions/PowerDataQuery";
import { IContextualMenuProps, Stack, Icon, Text,Checkbox,IconButton } from '@fluentui/react';
import { CommandButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import CustomMessageAlert from "../CustomMessageAlert/CustomMessageAlert";
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import rehypeRaw from 'rehype-raw';
import Markdown from 'markdown-to-jsx'
import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { Pivot, PivotItem, MessageBar, MessageBarType, } from '@fluentui/react';
import { ChoiceGroup, IChoiceGroupOption, IChoiceGroupStyles } from '@fluentui/react/lib/ChoiceGroup';
import StepProgress from './StepProgress';
import { PrimaryProductsPopup } from '../PlanningCategoryDialog/PrimaryProductsPopup';
import { Breadcrumb, BreadcrumbItem } from "@fluentui/react-components";
import { FolderRegular } from "@fluentui/react-icons";

import {
    IPersonaStyles,
    Persona,
    PersonaSize,
    PersonaPresence,
  } from '@fluentui/react/lib/Persona';


import './StaleContentMarker.css'

const actionCreators = {
    getContentMarkerReview,
    getArchiveArticle, 
    getImproveArticle,
    getMakeasReviewed,
    getReviewHistoryLog,
};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
    apiResponseState: state.apiResponseState,
    reviewContentMarker: state.reviewContentMarker,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

interface IMessageState {
    showMessage: boolean,
    messageType: string,
    message: string,
    onDismiss?: () => void
}

interface IScanIssueData {
    content?: string;
    context?: string;
    category?: string;
    status?: string;
}

interface IListItem {
    content: string;
    context: string;
    category?: string;
    status: string;
}

// const options: IChoiceGroupOption[] = [
//     { key: '0', text: 'Rubik' },
//     { key: '1', text: 'C3' },
//     { key: '2', text: 'ContentIdea' },
// ];

const personaStyles: Partial<IPersonaStyles> = { root: { margin: '0 0 10px 0' } };

const apiService = getAPIService().issueCenterService; 

const rubikUrl = `${process.env.REACT_APP_RUBIK_API_URL}`;

class ErrorBoundary extends Component {
    state = {
        hasError: false,
        error: null,
        errorInfo: null,
    };
    constructor(props) {
        super(props);
        // this.state = {
        //     hasError: false,
        //     error: null,
        //     errorInfo: null,
        // };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
    }

    render() {
        if (this.state.hasError) {
            // return <div>An error occurred: {this.state.error?.message}</div>;
            return <div></div>;
        }

        return this.props.children;
    }
}

const StaleContent = ({ datamart, newDiffEditorData, newNavigationDiffEditorData }) => {
    return (
        <ErrorBoundary>
            <>
                {/* <ReactMarkdown children={newDiffEditorData} remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw as any]} /> */}
                <Markdown>{newDiffEditorData}</Markdown>
            </>
        </ErrorBoundary>
    );
}


/**
 * broken link checker
 * @param props 
 * @returns 
 */
function StaleContentMarker(props: StoreProps & DispatchProps) {
    const { accounts } = useMsal();
    const [search] = useSearchParams();
    const requesturl = search.get('url')
    const ticketID = search.get('ticketID')
    const curationID = search.get('curationID')
    const datamart = search.get('datamart')
    const jobID = search.get('jobID')
    const pathArr = useLocation().pathname.split('/')
    const userAccount = useAccount(accounts[0]);

    const history = useNavigate();

    // set the healing complete params
    let healingCompleteParams: IHealingCompleteParams = {
        reviewType: "",
        requesturl: requesturl,
        fixerPath: pathArr[pathArr.length-1],
        traceID: ticketID,
        curationID: curationID,
        archiveDays: "120",
        renewDays: "30",
        completeTitle: "Thank you!"
    }
    
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

    const [issueList, setIssueList] = useState<IScanIssueData[]>([])

    const [buttonName, setButtonName] = useState<string>("Preview")

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    const [isTicketDialogOpen, setIsTicketDialogOpen] = useState<boolean>(false)

    const [ticketTip, setTicketTip] = useState<string>("")
    const [ticketList, setTicketList] = useState<any>([])

    // // Ticket Management ObservableValue
    // const collapsedTicket = new ObservableValue<boolean>(false);

    const [showReport, setShowReport] = useState<boolean>(false)

    const [reportDetailCss, setReportDetailCss] = useState<string>('')

    const [reportType, setReportType] = useState<string>('')

    const [currentExecuteRow, setCurrentExecuteRow] = useState(null);

    const [tableItems, setTableItems] = useState<IScanIssueData[]>([])

    const [checkbox, setCheckbox] = useState<boolean>(false)

    const [radioGroupValue, setRadioGroupValue] = useState<string>(null)
    const [radioOptions, setRadioOptions] = useState([])
    // const [radioPermissionValue, setRadioPermissionValue] = useState<string>(null)
    const [radioPermissionOptions, setRadioPermissionOptions] = useState([])
    const [currentStepIndex, setCurrentStepIndex] = useState(0)
    const [progressStepIndex, setProgressStepIndex] = useState(0)
    const [operateHistory, setOperateHistory] = useState([])

    const [articleButton, setArticleButton] = useState<string>("0")
    const [closeMessageBar, setCloseMessageBar] = useState<boolean>(true)
    const [isMarkAsNotReviewed, setIsMarkAsNotReviewed] = useState<boolean>(false)
    const [stepMarkAsNotReviewed, setStepMarkAsNotReviewed] = useState<boolean>(false)
    const [clickHere, setClickHere] = useState<boolean>(false)

    const [PlanningCategory, setPlanningCategory] = useState<string>("")
    const [PlanningCategoryGroup, setPlanningCategoryGroup] = useState<string>("")
    const [PlanningCategoryBusiness, setPlanningCategoryBusiness] = useState<string>("")
    const [NewPlanningCategory, setNewPlanningCategory] = useState<string>("")
    const [NewPlanningCategoryGroup, setNewPlanningCategoryGroup] = useState<string>("")
    const [NewPlanningCategoryBusiness, setNewPlanningCategoryBusiness] = useState<string>("")
    const [showNewPlanningCategory, setShowNewPlanningCategory] = useState<boolean>(false)

    const [pcyControls, setpcyControls] = useState<boolean>(false)

    // const collapsedBaseline = new ObservableValue<boolean>(false);
    const [collapsedBaseline, setCollapsedBaseline] = useState<boolean>(true)
    function onCollapseBaselineClicked() {
        // collapsedBaseline.value = !collapsedBaseline.value;
        setCollapsedBaseline(!collapsedBaseline);
    };

    /**
     * Tab bar related
     */
    const [tabGroupNames, setTabGroupNames] = useState<string[]>(['Content'])

    /** Initialize editor data state */
    const [newDiffEditorData, SetNewDiffEditorData] = useState<string>("");
    const [newNavigationDiffEditorData, SetNewNavigationDiffEditorData] = useState<string>("");
    const [newMetaDiffEditorData, SetNewMetaDiffEditorData] = useState<any>([]);

    const _columns = [
        { key: 'column1', name: 'Property', fieldName: 'PropertyName', minWidth: 200, maxWidth: 300, isResizable: true },
        {
            key: 'column2', name: 'Value', fieldName: 'Value', minWidth: 200, maxWidth: 400, isResizable: true,
            onRender: (item) => {
                const formattedValue = item.Value ? item.Value.replace(/\|\|/g, '\n') : '';
                return (
                    <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                        {formattedValue}
                    </div>
                );
            }
        },
    ];

    const [messageState, setMessageState] = useState<IMessageState>(() => {
        return {
            showMessage: false,
            messageType: '',
            message: '',
            onDismiss: null
        }
    })

    /**
     * Get the content from the api
     */
    useEffect(() => {

        // when the url is empty, show the error dialog
        if (!requesturl) {
            window.location.href = `https://aka.ms/ChironDocs`
            return
        }

        // Load data from API in effect
        const loadData = async () => {
            setIsLoading(true)

            // No permission to access the page
            isRemediationUser(ticketID);

            // call the api to get the content
            await props.getContentMarkerReview(requesturl, ticketID, curationID, datamart);

            var data = {
                ticketGuid: ticketID,
                url: requesturl,
                dataMart: datamart
            };
            getReviewHistoryLog(data).then(res => {
                if (res.Success) {
                    // if (res.Result.length > 0) {
                    //     var actions = res.Result.filter(x => x.Step == "Action");
                    //     if (actions.length > 0) {
                    //         setCheckbox(false);
                    //     } else {
                    //         var attestations = res.Result.filter(x => x.Step == "Attestation");
                    //         if (attestations.length > 0) {
                    //             setArticleButton(attestations[0].ActionId)
                    //             setCheckbox(true)
                    //             setRadioGroupValue("0")
                    //         }
                    //     }
                    // }
                    setOperateHistory(res.Result)
                }
            })

            setIsLoading(false);
            
        }

        loadData();
    }, [requesturl, ticketID, curationID])

    /**
     * handle review content change
     */
    useEffect(() => {
        if (props.reviewContentMarker) {
            // init tab
            const tabSet = new Set<string>()

            if (props.reviewContentMarker?.Message != null && props.reviewContentMarker?.Message?.length > 0) {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `${props.reviewContentMarker?.Message[0]}`,
                    onDismiss: dismissAlert
                })
                setTimeout(() => {
                    dismissAlert();
                }, 3500);
            }
            // if(props.reviewContent?.NavOriginalText) {
            //     tabSet.add('Navigation')
            //     SetNewNavigationDiffEditorData(props.reviewContent.NavChangedText)
            // }
            if(props.reviewContentMarker?.ArticleInfo?.Content?.ContentData) {
                tabSet.add('Content')
                SetNewDiffEditorData(props.reviewContentMarker?.ArticleInfo?.Content?.ContentData)
                SetNewNavigationDiffEditorData(props.reviewContentMarker?.ArticleInfo?.Content?.ContentData)
            }
            if(props.reviewContentMarker?.ArticleInfo?.Content?.MetaData) {
                tabSet.add('Metadata')
                var metaData = JSON.parse(props.reviewContentMarker?.ArticleInfo?.Content?.MetaData);
                SetNewMetaDiffEditorData(metaData);
            }

            setPlanningCategory(props.reviewContentMarker?.ArticleInfo?.PlanningCategory);
            setPlanningCategoryGroup(props.reviewContentMarker?.ArticleInfo?.PlanningCategoryGroup);
            setPlanningCategoryBusiness(props.reviewContentMarker?.ArticleInfo?.PlanningCategoryBusiness);

            setNewPlanningCategory(props.reviewContentMarker?.ArticleInfo?.PlanningCategory_New);
            setNewPlanningCategoryGroup(props.reviewContentMarker?.ArticleInfo?.PlanningCategoryGroup_New);
            setNewPlanningCategoryBusiness(props.reviewContentMarker?.ArticleInfo?.PlanningCategoryBusiness_New);

            setShowNewPlanningCategory(props.reviewContentMarker?.ArticleInfo?.ShowNewPlanningCategory);

            setTabGroupNames(Array.from(tabSet))

            // switch (datamart) {
            //     case "CCISCSSWiki":
            //     case "CCISADOWiki":

            //         break;
            //     case "CCISLMC":

            //         break;
            //     default:
            //         break;
            // }
            
            var options = [];
            var permissionOptions = [];
            props.reviewContentMarker?.ArticleInfo?.ArchiveLinks?.map((item: any, index: any) => {
                if (item.HavePermission) {
                    options.push({ key: index.toString(), text: item.Name })
                } else {
                    permissionOptions.push({ key: index.toString(), text: item.Name })
                }
            });
            setRadioOptions(options)
            setRadioPermissionOptions(permissionOptions)

        }
    }, [props.reviewContentMarker])

    function _onChange(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
        setRadioGroupValue(option.key)
        // setRadioPermissionValue("-1");
    }

    // function _onChangePermission(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
    //     // setRadioPermissionValue(option.key)
    //     setRadioGroupValue("-1");
    // }

    function clickMakeasReviewed(rollback) {
        var data = {
            ticketGuid: ticketID,
            curationId: curationID,
            dataMart: datamart,
            rollback: rollback,
        }

        setIsSubmitting(true)
        getMakeasReviewed(data).then(res => {
            setIsSubmitting(false)

            if (res.Success) {
                if (rollback) {
                    setMessageState({
                        messageType: 'success',
                        showMessage: true,
                        message: 'Congratulations, you have successfully reversed the review action. Please re-attest your article.'
                    })
                    
                    setCurrentStepIndex(0);
                    setProgressStepIndex(0);
                    setIsMarkAsNotReviewed(false);
                    setStepMarkAsNotReviewed(false);
                    setClickHere(false)
                    setCheckbox(false);
                    isRemediationUser(ticketID);
                } else {
                    setMessageState({
                        messageType: 'success',
                        showMessage: true,
                        message: 'Congratulations, you have successfully attested.'
                    })
                    
                    setCurrentStepIndex(2);
                    setProgressStepIndex(2);
                    setIsMarkAsNotReviewed(true);
                    setStepMarkAsNotReviewed(true);
                    setCheckbox(false);
                }
                
                var data = {
                    ticketGuid: ticketID,
                    url: requesturl,
                    dataMart: datamart
                };
                getReviewHistoryLog(data).then(res => {
                    if (res.Success) {
                        setOperateHistory(res.Result)
                    }
                })
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `${res.ErrorMessage}`,
                    onDismiss: dismissAlert
                })
            }

            setTimeout(() => {
                dismissAlert();
            }, 3500);

        });
    }

    function clickImproveArticle() {
        var data = {
            ticketGuid: ticketID,
            curationId: curationID,
            dataMart: datamart,
        }

        setIsLoading(true)
        getImproveArticle(data).then(res => {
            setIsLoading(false)
            if (res.Success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
    
                // setIsTicketDialogOpen(true);
                // setTicketTip("To improve the article, please select one of the following editing tools:")
                // setTicketList(props.reviewContentMarker.ArticleInfo.ImproveLinks);

                setTimeout(() => {
                    window.location.href = props.reviewContentMarker.ArticleInfo.ImproveLinks[radioGroupValue].Url;
                }, 2500);

                // var url = rubikUrl + `/improve?AssetType=Article&AssetURL=${requesturl}`;
                // window.location.href = url;
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `${res.ErrorMessage}`,
                    onDismiss: dismissAlert
                })
            }

            setTimeout(() => {
                dismissAlert();
            }, 3500);

        });

    }

    function clickArchiveArticle() {
        var data = {
            ticketGuid: ticketID,
            curationId: curationID,
            dataMart: datamart,
        }
        
        setIsLoading(true)
        getArchiveArticle(data).then(res => {
            setIsLoading(false)
            if (res.Success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
    
                // setIsTicketDialogOpen(true);
                // setTicketTip("To archive the article, please select one of the following editing tools:")
                // setTicketList(props.reviewContentMarker.ArticleInfo.ArchiveLinks);
                
                setTimeout(() => {
                    window.location.href = props.reviewContentMarker?.ArticleInfo?.ArchiveLinks[radioGroupValue].Url;
                }, 2500);

                // var url = rubikUrl + `/archive?AssetType=Article&AssetURL=${requesturl}&RedirectIt=No`
                // window.location.href = url;
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `${res.ErrorMessage}`,
                    onDismiss: dismissAlert
                })
            }

            setTimeout(() => {
                dismissAlert();
            }, 3500);

        });
    }

    /**
     * check if the user is in the remediation user list
     * @returns 
     */
    function isRemediationUser(ticketID) {

        getAuthandstatus(ticketID).then(res => {
            debugger
            if (res.Success) {
                if (res.Result.Auth.Code != 200) {
                    healingCompleteParams.reviewType = 'NoPermission'
                    healingCompleteParams.completeTitle = "Thank you!"
                    history(`/apps/close`, { state: healingCompleteParams })
                    return;
                }

                if (res.Result.Status.Ticket.State == "Closed") {

                    setCurrentStepIndex(2);
                    setProgressStepIndex(2);
                    setIsMarkAsNotReviewed(true);
                    setStepMarkAsNotReviewed(true);
                    setCheckbox(false);
                    return;
                }
                
                switch (res.Result.Status.Article.State) {
                    case "Attestation":
                        setCurrentStepIndex(1);
                        setProgressStepIndex(1);
                        
                        setArticleButton(res.Result.Status.Article.ActionId)
                        setCheckbox(true)
                        setRadioGroupValue("0")
                        break;
                    case "Action":
                        setCurrentStepIndex(2);
                        setProgressStepIndex(2);
                        setCloseMessageBar(false)
                        setCheckbox(false)
                        
                        healingCompleteParams.reviewType = 'Ticket Close'
                        healingCompleteParams.completeTitle = "Thank you!"
                        history(`/apps/close`, { state: healingCompleteParams })
                        break;
                    default:
                        setCurrentStepIndex(0);
                        setProgressStepIndex(0);
                        setCheckbox(false)
                        break;
                }

            }

        })

    }

    /**
     * Collapse or expand the Ticket Management
     */
    // function onCollapseTicketClicked() {
    //     collapsedTicket.value = !collapsedTicket.value;
    // };

    const onDismiss = () => {
        setIsDialogOpen(false)
    };

    const onTicketDismiss = () => {
        setIsTicketDialogOpen(false)
    };
    
    const dismissReportDetail = () => {
        setReportDetailCss('report-detail-form-out')
        setTimeout(()=>{
            setShowReport(false)
        },500)
    }

    const dismissAlert = () => {
        setMessageState({
            messageType: '',
            showMessage: false,
            message: ''
        })
    }

    const submitReportDetail = async(exceptionType: string,businessJustificationValue: string,expirationDate: string) => {
        setIsLoading(true)
        const today = formatDateToUTCStringDate(new Date())
        const createParam = {
            issueData:[{
                articleUrl: search.get('url'),
                content: currentExecuteRow.tableItem.content,
                exceptionType: exceptionType,
                sourceApp: 'CHIRON',
                reporter: userAccount.username,
                reportTime: today,
                riskArea: 'BrokenLink',
                businessJustification: businessJustificationValue,
                startTime: today,
                expireTime: formatDateToUTCStringDate(new Date(expirationDate)),
            }]
        }
        try {
            const data = await apiService.createIssueReport(createParam);
            if(data.success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
                setTimeout(()=>{
                    dismissAlert()
                }, 3000)
                setShowReport(false)
                getReportedBrokenLink()
            }
        }catch(error){
            setMessageState({
                messageType: 'error',
                showMessage: true,
                message: `${error.errorMessage}`,
                onDismiss: dismissAlert
            })
        }finally {
            setIsLoading(false)
        }
    }

    const getReportedBrokenLink = () => {
        setIsLoading(true)
        const requestUrl = search.get('url')
        const orgList = [...issueList]
        apiService.getIssueList(requestUrl, userAccount.username, issueList, 'BrokenLink').then(res => {
            res.issueData.forEach(issue => {
                orgList.forEach(item => {
                    if(item.content === issue.content && issue.issueId ) {
                        item.status = `Reported as ${issue.exceptionType}`
                    }
                })
            })
            setTableItems(orgList)
            setIsLoading(false)
        })
    }

    /**
     * build data list columns
     * @returns 
     */
    // function buildColumns(): any {
    //     const columns = [
    //         {
    //             id: "content",
    //             name: "Link",
    //             maxWidth: 1000,
    //             readonly: true,
    //             renderCell: renderChildLinkColumn,
    //             sortProps: {
    //                 ariaLabelAscending: "Sorted low to high",
    //                 ariaLabelDescending: "Sorted high to low",
    //             },
    //             width: new ObservableValue(-1000),
    //         },
    //         {
    //             id: "context",
    //             name: "Link text",
    //             maxWidth: 500,
    //             readonly: true,
    //             renderCell: renderSimpleCell,
    //             sortProps: {
    //                 ariaLabelAscending: "Sorted low to high",
    //                 ariaLabelDescending: "Sorted high to low",
    //             },
    //             width: new ObservableValue(-500),
    //         },
    //         {
    //             id: "status",
    //             name: "Status",
    //             maxWidth: 300,
    //             readonly: true,
    //             renderCell: renderSimpleCell,
    //             sortProps: {
    //                 ariaLabelAscending: "Sorted low to high",
    //                 ariaLabelDescending: "Sorted high to low",
    //             },
    //             width: new ObservableValue(-300),
    //         },
    //         {
    //             id: "actions",
    //             name: "Actions",
    //             maxWidth: 300,
    //             readonly: true,
    //             renderCell: renderButtonCell,
    //             width: new ObservableValue(-300),
    //         }

    //     ];

    //     return columns;
    // }

    // const buildTableItems = () => {
    //     return new ArrayItemProvider<IListItem>(
    //         tableItems.map(item => {
    //             return {
    //                 content: item.content,
    //                 context: item.context,
    //                 status: item.status
    //             }
    //          })
    //     )
    // }

    const buttonClick = (type: string, currentRow: {tableItem: IListItem, rowIndex: number}) => {
        setReportType(type)
        setShowReport(true)
        setCurrentExecuteRow(currentRow)
        setReportDetailCss('report-detail-form-in')
    }

    // function renderButtonCell(
    //     rowIndex: number,
    //     columnIndex: number,
    //     tableColumn: ITableColumn<IListItem>,
    //     tableItem: IListItem) {
    //         const menuProps: IContextualMenuProps = {
    //             onItemClick(ev, item) {
    //                 buttonClick(item.key,{tableItem,rowIndex})
    //             },
    //             items: [
    //                 {
    //                     key: 'falsePositive',
    //                     text: 'Report as false positive'
    //                 },
    //                 {
    //                     key: 'exception',
    //                     text: 'Set an exception'
    //                 },
    //             ]
    //         }
    //         return (
    //             <SimpleTableCell
    //                 columnIndex={columnIndex}
    //                 tableColumn={tableColumn}
    //                 key={tableColumn.id}
    //                 contentClassName="bolt-table-cell-content-with-inline-link no-v-padding"
    //                 >
    //                     {
    //                         tableItem.status === 'Broken' &&
    //                         <CommandButton iconProps={{iconName: 'Add'}} text="New action" menuProps={menuProps}/>
    //                     }
    //             </SimpleTableCell>
    //         )
    // }

    /**
   * Render ContentId cell
   * @param rowIndex 
   * @param columnIndex 
   * @param tableColumn 
   * @param tableItem 
   * @returns 
   */
    // function renderChildLinkColumn(
    //     rowIndex: number,
    //     columnIndex: number,
    //     tableColumn: ITableColumn<IListItem>,
    //     tableItem: IListItem) {
    //     const { content } = tableItem

    //     return (
    //         <SimpleTableCell
    //             columnIndex={columnIndex}
    //             tableColumn={tableColumn}
    //             key={"col-" + columnIndex}
    //             contentClassName="bolt-table-cell-content-with-inline-link no-v-padding"
    //         >
    //             {
    //                 content && content.toString() !== '' ?
    //                     (
    //                         <Link
    //                             className="fontSizeM font-size-m text-ellipsis bolt-table-link bolt-table-inline-link"
    //                             excludeTabStop
    //                             href={content}
    //                             target={"_blank"}
    //                         >
    //                             {content}
    //                         </Link>
    //                     )
    //                     :
    //                     (
    //                         <div className="flex-row scroll-hidden">
    //                             {content}
    //                         </div>
    //                     )
    //             }

    //         </SimpleTableCell>
    //     );
    // }


    const UserListItem = ({ user }) => (
        <Stack
            tokens={{ childrenGap: 12 }}
            styles={{
                root: {
                    padding: '12px 20px',
                    borderBottom: '1px solid #eee',
                    borderRadius: 8,
                    background: '#fff',
                },
            }}
        >
            <Stack horizontal tokens={{ childrenGap: 16 }} verticalAlign="center">
                <Persona
                    text={user.DisplayName}
                    size={PersonaSize.size32}
                    presence={PersonaPresence.none}
                    hidePersonaDetails
                    styles={{
                        root: {
                            minWidth: 32,
                        },
                    }}
                />

                <Stack grow tokens={{ childrenGap: 6 }}>
                    <Text variant="medium" styles={{ root: { fontWeight: 600 } }}>
                        {user.DisplayName}
                    </Text>

                    <Text variant="small" styles={{ root: { fontWeight: 500, color: '#333' } }}>
                        {user.Action}
                    </Text>

                    <Text variant="small" styles={{ root: { color: '#666' } }}>
                        {formatDateToReadableString(user.ReviewDate)}
                    </Text>
                </Stack>
            </Stack>
        </Stack>
    );

    function formatDateToReadableString(isoString) {
        const date = new Date(isoString);

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'

        return `${month} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
    }
      
    function saveCorrectPlanningCategory(product) {
        var tagName = product.tagName.split("/");

        if (tagName[0] + "/" + tagName[1] + "/" + tagName[2] ==
            (NewPlanningCategoryBusiness ?? "") + "/" + (NewPlanningCategoryGroup ?? "") + "/" + (NewPlanningCategory ?? "")
        ) {
            setpcyControls(false)

            setMessageState({
                messageType: 'success',
                showMessage: true,
                message: 'Successfully reported!'
            })

            setTimeout(() => {
                dismissAlert();
            }, 1500);
            return;
        }

        var data = {
            TypeName: "",
            OldValue: PlanningCategoryBusiness + "/" + PlanningCategoryGroup + "/" + PlanningCategory,
            NewValue: tagName[0] + "/" + tagName[1] + "/" + tagName[2],
            Reason: "",
            TicketGuid: ticketID,
        };

        setIsLoading(true);
        correctPlanningCategory(data).then(res => {
            setIsLoading(false);

            if (res.Success) {

                setNewPlanningCategory(tagName[2]);
                setNewPlanningCategoryGroup(tagName[1]);
                setNewPlanningCategoryBusiness(tagName[0]);

                if (PlanningCategoryBusiness + "/" + PlanningCategoryGroup + "/" + PlanningCategory ==
                    tagName[0] + "/" + tagName[1] + "/" + tagName[2]) {
                    setShowNewPlanningCategory(false);
                } else {
                    setShowNewPlanningCategory(true);
                }

                setpcyControls(false)

                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })

                setTimeout(() => {
                    dismissAlert();
                }, 1500);
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Report failed, detail:${res.ErrorMessage ? res.ErrorMessage : 'Unknown error, please try again later!'}`,
                    onDismiss: dismissAlert
                })

                setTimeout(() => {
                    dismissAlert();
                }, 2000);
            }

        })
    }


    return (
        <div style={{ width: "100%" }}>
            {/* <div className="flex-grow">
                <br />
            </div> */}

            <div style={{ width: '50%', position: 'relative', marginLeft: "5%" }}>
                <CustomMessageAlert
                    type={messageState.messageType}
                    message={messageState.message}
                    showAlert={messageState.showMessage}
                    onDismiss={messageState.onDismiss}
                />
            </div>


            <div className="ms-Grid-row" style={{ width: "100%" }}>
                <div className="ms-Grid-col ms-sm8 ms-md3 ms-lg8 msacct-content" style={{ border: "0px" }}>

    
                    <div style={{ height: "96vh" }}>

                        {
                            (PlanningCategory != null && PlanningCategory != "") ?
                                <div>
                                    <div className="breadcrumb-wrapper" onClick={() => {
                                        setpcyControls(true)
                                    }}>
                                        <FolderRegular className="breadcrumb-icon" />
                                        <span className="breadcrumb-text">
                                            <span className="prefix">PCY:</span>
                                            <span className="breadcrumb-item">{PlanningCategoryBusiness}</span>
                                            <span className="separator">{'>'}</span>
                                            <span className="breadcrumb-item">{PlanningCategoryGroup}</span>
                                            <span className="separator">{'>'}</span>
                                            <span className="breadcrumb-item">{PlanningCategory}</span>
                                        </span>
                                    </div>

                                    {
                                        showNewPlanningCategory ?
                                            <div style={{ marginBottom: "5px", width: "99%", marginTop: "5px" }}>
                                                <MessageBar
                                                    messageBarType={MessageBarType.warning}
                                                    isMultiline={true}
                                                    // dismissButtonAriaLabel="Close"
                                                    truncated={true}
                                                    messageBarIconProps={{ iconName: 'IncidentTriangle' }}
                                                    styles={{
                                                        root: {
                                                            // borderRadius:"10px"
                                                        },
                                                        icon: { fontSize: '20px', marginRight: 8 },
                                                        innerText: { color: '#333' }
                                                    }}
                                                >
                                                    The PCY for this article has been updated to "<span className='fontWeight'>
                                                        {NewPlanningCategoryBusiness} {'>'} {NewPlanningCategoryGroup} {'>'} {NewPlanningCategory}
                                                    </span>". There may be a synchronination delay of up to 72 hours between different systems.
                                                </MessageBar>
                                            </div> : null
                                    }
                                </div> : null
                        }

                        <Stack tokens={{ childrenGap: 8 }} className="customCardStale" style={{ padding: "16px 5px 0px 16px", marginBottom: "3%" }}>
                            <div style={{ flexWrap: "wrap", maxHeight: "100%", overflowWrap: 'break-word' }}>
                                <DefaultButton
                                    text="Visit site" iconProps={{ iconName: "PreviewLink" }}
                                    className='floatBtu' onClick={() => {
                                        window.location.href = requesturl;
                                    }} style={{ zIndex: "9" }}
                                />

                                <div className="page-content page-content-top" style={{ paddingLeft: "5px", paddingRight: "5px" }}>

                                    <Pivot aria-label="Basic Pivot Example">
                                        <PivotItem
                                            headerText="Preview"
                                            headerButtonProps={{
                                                'data-order': 1,
                                                'data-title': 'My Files Title',
                                            }}
                                        >
                                            {
                                                (datamart == "CCISCSSWiki" || datamart == "CCISADOWiki") ?
                                                    <StaleContent datamart={"CCISCSSWiki"} newDiffEditorData={newDiffEditorData} newNavigationDiffEditorData={newNavigationDiffEditorData} /> :
                                                    <ArticleDiff previousDraft={newDiffEditorData} newDraft={newNavigationDiffEditorData} />
                                            }
                                            {/* <StaleContent datamart={"CCISCSSWiki"} newDiffEditorData={newDiffEditorData} newNavigationDiffEditorData={newNavigationDiffEditorData} /> */}
                                        </PivotItem>
                                        <PivotItem headerText="Metadata">
                                            {
                                                (newMetaDiffEditorData.length > 0) ?
                                                    < DetailsList
                                                        items={newMetaDiffEditorData}
                                                        columns={_columns}
                                                        setKey="set"
                                                        layoutMode={DetailsListLayoutMode.justified}
                                                        selectionMode={SelectionMode.none}
                                                        ariaLabelForSelectionColumn="Toggle selection"
                                                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                                        checkButtonAriaLabel="select row"
                                                    />
                                                    :
                                                    <span style={{ marginLeft: "10px", fontWeight: "700" }}>
                                                        No metadata found.
                                                    </span>
                                            }

                                        </PivotItem>
                                    </Pivot>

                                    <div className="flex-grow">
                                        <br />
                                    </div>

                                </div>
                            </div>

                        </Stack>

                    </div>

                </div>
                <div className="ms-Grid-col ms-sm4 ms-md3 ms-lg4 msacct-content" style={{ border: "0px", padding: "0px", margin: "0px" }}>
                    {/* <ContentMarkerRight id={requestid} originalIssueList={issueList} title='Content Issues' /> */}

                    <div style={{ height: "96vh", overflowY: "scroll", margin: "0px", padding: "0px" }}>
                        <div style={{ margin: "15px 15px 12px", marginTop: "20px" }}>
                            <StepProgress currentStepIndex={progressStepIndex} onClickStepIndex={(key)=>{
                                if (stepMarkAsNotReviewed) {
                                    return;
                                }
                                switch (key) {
                                    case 1:
                                        if (progressStepIndex == 2) {
                                            setClickHere(true)
                                            setCloseMessageBar(true)
                                        }
                                        setCurrentStepIndex(0);
                                        setCheckbox(false)
                                        setIsMarkAsNotReviewed(false);
                                        break;
                                    case 2:
                                        if (progressStepIndex == 2) {
                                            setClickHere(true)
                                            setCloseMessageBar(false)
                                        }
                                        setCurrentStepIndex(2);
                                        setCheckbox(false)
                                        setIsMarkAsNotReviewed(stepMarkAsNotReviewed);
                                        break;
                                    default:
                                        break;
                                }
                            }} />
                        </div>

                        <Stack tokens={{ childrenGap: 8 }} className="customCardStale">
                            <div className="flex-row approveOpption" style={{ flexWrap: "wrap" , maxHeight: "90vh",overflowWrap: 'break-word'}}>

                                {
                                    isMarkAsNotReviewed ?
                                        <>
                                            <div><h1 className='rightTitle' style={{ color: "#00a1f1" }}>Congratulations!</h1></div>
                                            <div className="flex-column" style={{ width: "100%", wordWrap: "break-word" }}>
                                                <p>
                                                    You have selected "<span className='fontWeight'>Mark as reviewed</span>," This article has been reviewed and no further action is needed for the next {props.reviewContentMarker?.TicketInfo?.RenewDays} days.
                                                </p>
                                            </div>
                                            <div>
                                                <h3 style={{ fontSize: "16px", fontWeight: "600", marginTop: "5px", marginBottom: "10px" }}>
                                                    {/* Note that You still can revert the review action: */}
                                                    Note that you can still revert the action:
                                                </h3>
                                            </div>
                                            <div>
                                                <Checkbox
                                                    onChange={(event, checked) => {
                                                        setCheckbox(checked);
                                                        setRadioGroupValue(radioGroupValue == null ? "0" : radioGroupValue);
                                                    }}
                                                    checked={checkbox}
                                                    className='customCheckbox'
                                                    onRenderLabel={() => (
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <div>
                                                                As the accountable owner of this article, I understand the following option:
                                                            </div>
                                                            <ul className="blue-bullets">
                                                                <li>
                                                                    <span className='fontWeight'>Mark as not reviewed</span> - Confirms the review action I submitted for this article will be reverted.
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                            <div className='button-top' style={{ marginTop: "0px" }}>
                                                <PrimaryButton text="Mark as not reviewed" disabled={!checkbox} iconProps={{ iconName: "CheckMark" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                                    clickMakeasReviewed(true);
                                                }} />
                                            </div>
                                            <div>
                                                <p>
                                                    For information on how to update internal content, please refer to this article: <a href='https://internal.evergreen.microsoft.com/en-us/topic/0bfe63e9-47b4-40f0-a35d-9f9aa0e58b21'>Internal Support Content request landing page</a>.
                                                </p>
                                            </div>
                                        </> :
                                        <>
                                            {
                                                currentStepIndex == 0 ?
                                                    <>

                                                        {
                                                            progressStepIndex == 0 ?
                                                                <>
                                                                    <div><h1 className='rightTitle'>Action required</h1></div>
                                                                    <div className="flex-column" style={{ width: "100%", wordWrap: "break-word" }}>
                                                                        {/* <p>
                                                                            Please make sure that your article's information is accurate. Once you click one of the buttons below and take the necessary
                                                                            actions, your article will be renewed for another <span style={{ color: "red" }}>{props.reviewContentMarker?.TicketInfo?.RenewDays} days</span>.
                                                                        </p>
                                                                        <p>
                                                                            Select one of the buttons below to mark this article as reviewed, improve this article or archive this article.
                                                                        </p> */}
                                                                        <p>
                                                                            Please make sure that your article's information is accurate. Once you click one of the buttons below to take the necessary actions (mark this article as reviewed, improve or archive this article).
                                                                        </p>
                                                                    </div>
                                                                </> :
                                                                <div style={{ marginBottom: "10px" }}>
                                                                    <MessageBar
                                                                        messageBarType={MessageBarType.warning}
                                                                        isMultiline={true}
                                                                        dismissButtonAriaLabel="Close"
                                                                        truncated={true}
                                                                        messageBarIconProps={{ iconName: 'IncidentTriangle' }}
                                                                        onDismiss={() => {
                                                                            setCloseMessageBar(false)
                                                                        }}
                                                                    >
                                                                        This article status data is from UDP. There may be a synchronination delay of up to 48 hours between different systems. If you or any others have already improved or archived this article on the authoring tool, please ignore this step. The status will be synced automatically.
                                                                    </MessageBar>
                                                                </div>
                                                        }


                                                        <div>
                                                            <Checkbox disabled={clickHere}
                                                                onChange={(event, checked) => {
                                                                    setCheckbox(checked);
                                                                    setRadioGroupValue(radioGroupValue == null ? "0" : radioGroupValue);
                                                                }}
                                                                checked={checkbox}
                                                                className='customCheckbox'
                                                                onRenderLabel={() => (
                                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                        <div>
                                                                            As the accountable owner of this article, I understand the following options:
                                                                        </div>
                                                                        <ul className="blue-bullets">
                                                                            <li>
                                                                                <span className='fontWeight'>Mark as reviewed</span> - Confirms the article will be renewed and no further action is needed for the next {props.reviewContentMarker?.TicketInfo?.RenewDays} days.
                                                                            </li>
                                                                            <li>
                                                                                <span className='fontWeight'>Improve this article</span> - Indicates the article requires updates to ensure it remains accurate and up to date.
                                                                            </li>
                                                                            <li>
                                                                                <span className='fontWeight'>Archive this article</span> - Indicates the article is no longer needed and should be archived.
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                        <div className='button-top'>
                                                            <PrimaryButton text="Mark as reviewed" disabled={!checkbox} iconProps={{ iconName: "CheckMark" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                                                clickMakeasReviewed(false);
                                                            }} />
                                                        </div>
                                                        <div className='button-top'>
                                                            <PrimaryButton text="Improve this article" disabled={!checkbox} iconProps={{ iconName: "Edit" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                                                clickImproveArticle();
                                                            }} />
                                                        </div>
                                                        <div className='button-top'>
                                                            <PrimaryButton text="Archive this article" disabled={!checkbox} iconProps={{ iconName: "FolderHorizontal" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                                                clickArchiveArticle();
                                                            }} />
                                                        </div>
                                                    </> : null
                                            }
                                            {
                                                currentStepIndex == 1 ?
                                                    <>
                                                        {
                                                            closeMessageBar ?
                                                                <div style={{ marginBottom: "10px" }}>
                                                                    <MessageBar
                                                                        messageBarType={MessageBarType.warning}
                                                                        isMultiline={true}
                                                                        dismissButtonAriaLabel="Close"
                                                                        truncated={true}
                                                                        messageBarIconProps={{ iconName: 'IncidentTriangle' }}
                                                                        onDismiss={() => {
                                                                            setCloseMessageBar(false)
                                                                        }}
                                                                    >
                                                                        This article status data is from UDP. There may be a synchronination delay of up to 48 hours between different systems. If you or any others have already improved or archived this article on the authoring tool, please ignore this step. The status will be synced automatically.
                                                                    </MessageBar>
                                                                </div> : null
                                                        }

                                                        <div className="flex-column" style={{ width: "100%", wordWrap: "break-word" }}>
                                                            <p>
                                                                {/* You have decided to {articleButton == "7" ? "archive" : "improve"} this article. 
                                                                Please click the following button to go to the target platform to
                                                                {articleButton == "7" ? " archive this article" : " improve this article"}. 
                                                                If you want to change your selection please click <span className='fontWeight'>Attesting</span> icon. */}

                                                                {/* You have selected to {articleButton == "7" ? "archive" : "improve"} this article. Please click the following button to {articleButton == "7" ? "archive" : "improve"} the article on the target platform. If you change your mind, click the above <span className='fontWeight' style={{ fontWeight: "800", fontSize: "15px" }}>Attesting</span> icon. */}
                                                                This article has been selected for {articleButton == "7" ? "archiving" : "improvement"}. To proceed, click the button below. If you change your mind, click the "<span className='fontWeight' style={{ fontWeight: "800", fontSize: "15px" }}>Attesting</span>" icon above.
                                                            </p>
                                                        </div>

                                                        {
                                                            articleButton == "7" ?
                                                                <div className='button-top' style={{ marginTop: "0px" }}>
                                                                    <PrimaryButton text="Archive this article" disabled={!checkbox} iconProps={{ iconName: "FolderHorizontal" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                                                        clickArchiveArticle();
                                                                    }} />
                                                                </div> :
                                                                <div className='button-top' style={{ marginTop: "0px" }}>
                                                                    <PrimaryButton text="Improve this article" disabled={!checkbox} iconProps={{ iconName: "Edit" }} primary={true} style={{ width: "55%" }} onClick={() => {
                                                                        clickImproveArticle();
                                                                    }} />
                                                                </div>
                                                        }

                                                    </> : null
                                            }
                                            {
                                                currentStepIndex == 2 ?
                                                    <>
                                                        <div><h1 className='rightTitle' style={{ color: "#00a1f1" }}>Congratulations!</h1></div>
                                                        <div className="flex-column" style={{ width: "100%", wordWrap: "break-word" }}>
                                                            {
                                                                articleButton == "7" ?
                                                                    <p>
                                                                        You have selected "<span className='fontWeight'>Archive this article</span>," this article needs to be modified and republished within the next {props.reviewContentMarker?.TicketInfo?.ArchiveDays} days.
                                                                    </p> :
                                                                    <p>
                                                                        You have selected "<span className='fontWeight'>Improve this article</span>," this article needs to be modified and republished within the next {props.reviewContentMarker?.TicketInfo?.ArchiveDays} days.
                                                                    </p>
                                                            }
                                                            <p>
                                                                For information on how to update internal content, please refer to this article: <a href='https://internal.evergreen.microsoft.com/en-us/topic/0bfe63e9-47b4-40f0-a35d-9f9aa0e58b21'>Internal Support Content request landing page</a>.
                                                            </p>
                                                        </div>

                                                    </> : null
                                            }

                                            {
                                                (currentStepIndex != 2 && radioOptions.length > 0) ?
                                                    <div style={{ margin: "15px 0px 0px 15px", fontWeight: "700" }}>
                                                        <div>
                                                            {/* Editting in */}
                                                            Select a platform below to edit the article:
                                                        </div>
                                                        <div className='radioGroup'>
                                                            <ChoiceGroup disabled={!checkbox} selectedKey={radioGroupValue} options={radioOptions} onChange={_onChange} label="" />
                                                        </div>

                                                        {
                                                            radioPermissionOptions.length > 0 ?
                                                                <div>
                                                                    <div style={{ marginTop: "10px" }}>
                                                                        {/* Submit change request through{' '}
                                                                        <span style={{ fontWeight: "500" }}>
                                                                            (For individuals who don't have the author permission)
                                                                        </span> */}
                                                                        If you don't have authoring permissions, select the option below to submit change request through a ticket:
                                                                    </div>
                                                                    <div className='permissionRadio'>
                                                                        <ChoiceGroup disabled={!checkbox} selectedKey={radioGroupValue} options={radioPermissionOptions} onChange={_onChange} label="" />
                                                                    </div>
                                                                </div> : null
                                                        }
                                                    </div> : null
                                            }
                                        </>
                                }

                                <div style={{ marginBottom: "10px" }}>
                                    <p>
                                        If you have any questions about <a href="https://aka.ms/ACCTUserGuide">Sonic</a>, <a href="https://aka.ms/Autohealing">Chiron</a>, or the proposed change above, please click <a href="https://aka.ms/ChironSupport">here</a> to create a ticket for assistance.
                                    </p>
                                </div>
                            </div>
                        </Stack>

                        <div className='articleHistory' style={{ marginTop: "10px", marginBottom: "25px" }}>
                            {/* <Card className="CardMargin flex-grow approveOpption staleCard"
                                collapsible={true}
                                collapsed={collapsedBaseline}
                                onCollapseClick={onCollapseBaselineClicked}
                                titleProps={{
                                    text: "Article Attestation History",
                                    ariaLevel: 1,
                                }}>
                                <Stack tokens={{ childrenGap: 12 }}>
                                    {operateHistory.map((user, index) => (
                                        <UserListItem key={index} user={user} />
                                    ))}
                                </Stack>
                            </Card> */}

                            <Stack tokens={{ childrenGap: 8 }} className="customCardStale">
                                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                                    <IconButton
                                        iconProps={{ iconName: collapsedBaseline ? 'ChevronDown' : 'ChevronRight' }}
                                        onClick={onCollapseBaselineClicked}
                                        title="Expand or collapse"
                                        ariaLabel="Expand or collapse"
                                        styles={{
                                            root: {
                                                color: '#000',
                                                fontSize: 12,
                                                marginTop: 2,
                                            },
                                            icon: {
                                                color: '#000',
                                                fontSize: 12,
                                            },
                                        }}
                                    />
                                    <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                                        Article Attestation History
                                    </Text>
                                </Stack>

                                {collapsedBaseline && (
                                    <Stack tokens={{ childrenGap: 12 }}>
                                        {operateHistory.map((user, index) => (
                                            <UserListItem key={index} user={user} />
                                        ))}
                                    </Stack>
                                )}
                            </Stack>

                        </div>
                    </div>

                    {/* <div>
                        {
                            isTicketDialogOpen ? (
                                <Dialog
                                    titleProps={{ text: "You successfully submitted the choice." }}
                                    footerButtonProps={[
                                        {
                                            text: "Close this window",
                                            primary: true,
                                            onClick: onTicketDismiss
                                        }
                                    ]}
                                    onDismiss={onTicketDismiss}
                                    calloutContentClassName='dialogStyle'
                                >
                                    <div>
                                        {ticketTip}
                                    </div>
                                    <ul style={{ marginBottom: "80px" }}>
                                        {ticketList.map((ticket, index) => (
                                            <li><a href={ticket.Url}>{ticket.Title}</a> {ticket.Description}</li>
                                        ))}
                                    </ul>
                                </Dialog>
                            ) : null
                        }
                    </div> */}

                    {/* <div>
                        {
                            isDialogOpen ? (
                                <Dialog
                                    titleProps={{ text: "Content Issues" }}
                                    footerButtonProps={[
                                        {
                                            text: "Close",
                                            onClick: onDismiss
                                        }
                                    ]}
                                    onDismiss={onDismiss}
                                    calloutContentClassName='issue-center-dialog'
                                >
                                    {
                                        showReport ?
                                            <Card className={reportDetailCss}>
                                                <div style={{ width: '100%' }}>
                                                    <ExceptionReportDialog
                                                        showReportExceptionDialog={showReport}
                                                        dismissReportDialog={dismissReportDetail}
                                                        onSubmit={submitReportDetail}
                                                        reportType={reportType}
                                                    />
                                                </div>
                                            </Card> :
                                            <Card className="flex-grow bolt-table-card report-detail-list" contentProps={{ contentPadding: false }}>
                                                <Table
                                                    ariaLabel="Basic Table"
                                                    columns={buildColumns()}
                                                    itemProvider={buildTableItems()}
                                                    role="table"
                                                    className="issue-center-table"
                                                    containerClassName="h-scroll-auto"
                                                />
                                            </Card>
                                    }
                                </Dialog>
                            ) : null
                        }
                    </div> */}

                </div>
            </div>

            {
                isLoading && <Spinner className='autohealing-loading' label='Loading...' size={SpinnerSize.large} />
            }

            {
                isSubmitting && <Spinner className='autohealing-loading' label='Submitting...' size={SpinnerSize.large} />
            }


            {
                pcyControls ?
                    <PrimaryProductsPopup onProductsChange={(product) => {
                        saveCorrectPlanningCategory(product[0])
                    }} defaultProducts={[
                        {
                            Children: null,
                            Key: "",
                            Name: (NewPlanningCategory ?? PlanningCategory),
                            tagName: (NewPlanningCategoryBusiness ?? PlanningCategoryBusiness) + "/"
                                + (NewPlanningCategoryGroup ?? PlanningCategoryGroup) + "/"
                                + (NewPlanningCategory ?? PlanningCategory)
                        }
                    ]} isOpen={pcyControls}
                        closeProductsPopup={(value) => {
                            setpcyControls(value)
                        }} /> : null
            }

        </div>
    )
}

export default connect<StoreProps, DispatchProps>(
    mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(StaleContentMarker);
